"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactResponsive = require("react-responsive");

var _reactIntl = require("react-intl");

var _reactRouterDom = require("react-router-dom");

var _Icon = _interopRequireDefault(require("../../../../../Icon"));

var _StyledLayout = require("../../../../../StyledLayout");

var _Elements = require("../../../../Elements");

var _Elements2 = require("./Elements");

var _Elements3 = require("../Menu/Elements");

var _Elements4 = require("../../../Adams/components/Topnav/Elements");

var _constants = require("../../../../constants/constants");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var NewtonTopNav = function NewtonTopNav(_ref) {
  var siteName = _ref.siteName,
      publicUrl = _ref.publicUrl,
      folders = _ref.folders,
      colour = _ref.colour;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      show = _useState2[0],
      setShow = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      showHamburgerMenu = _useState4[0],
      setShowHamburgerMenu = _useState4[1];

  var isTabletPortrait = (0, _reactResponsive.useMediaQuery)({
    query: '(min-width: 768px)'
  });
  (0, _react.useEffect)(function () {
    setTimeout(function () {
      setShow(true);
    }, 100);
  }, []);

  if (isTabletPortrait) {
    return /*#__PURE__*/_react["default"].createElement(_Elements2.TopnavMain, {
      show: show,
      colour: _constants.PORTFOLIO_THEME_COLOR[colour]
    }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
      to: publicUrl
    }, /*#__PURE__*/_react["default"].createElement(_Elements.Logo, {
      bold: true,
      uppercase: true,
      portfolioForeground1: true
    }, siteName)));
  }

  return /*#__PURE__*/_react["default"].createElement(_Elements2.StyledMobileTopnav, {
    p: "sm",
    flex: true,
    align: "center",
    justify: "space-between"
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: publicUrl,
    style: {
      flex: '1 1 auto',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },
    onClick: function onClick() {
      window.scrollTo(0, 0);
    }
  }, /*#__PURE__*/_react["default"].createElement(_Elements2.StyledLogo, {
    bold: true,
    uppercase: true,
    portfolioForeground1: true,
    singleLineText: true
  }, siteName)), showHamburgerMenu ? /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    svg: "close",
    onClick: function onClick() {
      setShowHamburgerMenu(false);
    },
    size: "xs"
  }) : /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    portfolioForeground1: true,
    underline: true,
    onClick: function onClick() {
      setShowHamburgerMenu(true);
    },
    style: {
      flex: '0 0 auto'
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.topnav.link.menu"
  })), showHamburgerMenu && /*#__PURE__*/_react["default"].createElement(_Elements4.MobileHamburgerMenu, {
    flex: true,
    column: true,
    style: {
      height: 'calc(100vh - 60px)',
      top: '60px'
    },
    align: "center"
  }, folders.map(function (folder, index) {
    return /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
      key: folder.id,
      large: true,
      center: true,
      portfolioForeground1: true,
      style: {
        marginBottom: folders.length !== index + 1 ? '24px' : '0',
        maxWidth: '272px'
      },
      as: "a"
    }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
      to: "".concat(publicUrl, "/gallery/").concat(folder.id),
      onClick: function onClick() {
        setShowHamburgerMenu(false);
      }
    }, folder.name));
  }), /*#__PURE__*/_react["default"].createElement(_StyledLayout.Box, {
    flex: true,
    justify: "center"
  }, folders.length !== 0 && /*#__PURE__*/_react["default"].createElement(_Elements3.StyledDivider, {
    fontColor: _constants.PORTFOLIO_THEME_COLOR[colour]
  })), /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    large: true,
    center: true,
    portfolioForeground1: true,
    mb: "md"
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: "".concat(publicUrl),
    onClick: function onClick() {
      setShowHamburgerMenu(false);
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.topnav.link.home"
  }))), /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    large: true,
    center: true,
    portfolioForeground1: true,
    mb: "md"
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: "".concat(publicUrl, "/about"),
    onClick: function onClick() {
      setShowHamburgerMenu(false);
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.topnav.link.about"
  }))), /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    large: true,
    center: true,
    portfolioForeground1: true,
    mb: "md"
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: "".concat(publicUrl, "/contact"),
    onClick: function onClick() {
      setShowHamburgerMenu(false);
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.topnav.link.contact"
  })))));
};

NewtonTopNav.defaultProps = {
  siteName: 'Dariane Sanche',
  publicUrl: ''
};
NewtonTopNav.propTypes = {
  siteName: _propTypes["default"].string,
  publicUrl: _propTypes["default"].string,
  folders: _propTypes["default"].arrayOf(_propTypes["default"].shape()).isRequired,
  colour: _propTypes["default"].string.isRequired
};
var _default = NewtonTopNav;
exports["default"] = _default;